import { render } from "./index.vue?vue&type=template&id=4fda18b4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=4fda18b4&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fda18b4"],['__file',"src/components/FormularioEdicaoAvulsa/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4fda18b4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4fda18b4', __exports__)) {
    console.log('reload')
    api.reload('4fda18b4', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=4fda18b4&scoped=true", () => {
    console.log('re-render')
    api.rerender('4fda18b4', render)
  })

}


export default __exports__